export const roundToNearestFiveCents = (amount: number): number => {
  return Math.round(amount * 20) / 20;
};
